{
    "actions": {
        "row": {
            "subscription": "Actions abonnement",
            "activate": "Activation",
            "terminal": "Actions TPE",
            "terminate": "Résiliation immédiate",
            "scheduled_terminate": "Résiliation programmée",
            "migrate": "Migration",
            "update_plan": "Modifier l'offre",
            "update_organization": "Modifier l'organisation",
            "add_envelope": "Créer enveloppe",
            "historics_access": "Historique du terminal"
        }
    },
    "filter": {
        "placeholder": {
            "last_source_ip": "Filtrer par IP",
            "sim_card_number": "Filtrer par SIM",
            "client": {
                "legal_name": "Filtrer par organisation",
                "code": "Filtrer par code client"
            },
            "plan_label": "Filtrer par libellé d'offre",
            "product_code": "Filtrer par code produit de l'offre"
        }
    },
    "keys": {
        "last_source_ip": "IP",
        "last_ssl_version": "Certificat",
        "last_connection": "Connecté le",
        "status": "Abo. passerelle",
        "sim_card_number": "SIM",
        "client": {
            "legal_name": "Organisation",
            "code": "Code client"
        },
        "plan_label": "Libellé offre",
        "product_code": "Code produit offre",
        "created_at": "Ajouté le",
        "activation_date": "Activé le",
        "resiliation_date": "Résiliation",
        "start_billing_date": "Facturation",
        "updated_at": "Date de mise à jour",
        "last_iccid_operator": "Opérateur SIM",
        "active_iccid_operator": "Opérateur SIM",
        "start_blacklist": "Bloqué le",
        "payludd_termination_date": "Résiliation Payludd",
        "last_payludd_connection_date": "Dernier appel Payludd"
    },
    "modal": {
        "terminate": {
            "title": "Résilier l'abonnement",
            "text": "Voulez vous résilier l'abonnement de ce terminal ?",
            "success": "L'abonnement a été résilié avec succès",
            "error": "Une erreur est survenue lors de la résiliation de l'abonnement",
            "scheduled": {
                "text": "Résiliation programmée de l'abonnement",
                "summary": "L'abonnement sera résilié le {{date}}",
                "payludd_1": "Le service Payludd sera automatiquement résilié.",
                "payludd_2": "Si votre application est à jour, elle sera automatiquement remise à zéro.",
                "payludd_3": "Sinon, il est recommandé de réinitialiser manuellement l'application",
                "success": "L'abonnement est maintenant programmé pour être résilié le {{date}}",
                "error": "Une erreur est survenue, la résiliation n'a pas pu être programmée."
            }
        },
        "activate": {
            "title": "Activer l'abonnement",
            "text": "Vous avez sélectionné l'offre \"{{planLabel}}\" pour activer cet abonnement.",
            "confirm": "Souhaitez-vous continuer ?",
            "success": "L'abonnement a été activé avec succès",
            "error": "Une erreur est survenue lors de l'activation de l'abonnement",
            "steps": {
                "select_plan": "Étape {{step}} sur {{maxStep}} : Sélection d'une offre à ajouter",
                "activate": "Étape {{step}} sur {{maxStep}} : Activation de l'abonnement"
            }
        },
        "migrate": {
            "title": "Déclarer une migration",
            "text": "Vous êtes sur le point de déclarer une migration pour cet abonnement.",
            "info": "La date de début de facturation pour cet abonnement sera reportée au :",
            "confirm": "Souhaitez-vous continuer ?",
            "success": "Facturation modifiée avec succès !",
            "error": "Une erreur est survenue lors de la déclaration de la migration"
        },
        "add_envelope": {
            "title": "Créer une enveloppe",
            "success": "Opération réalisée avec succès !",
            "error": {
                "default": "Echec de l'opération",
                "already_exists": "Il existe déjà une enveloppe programmée pour ce terminal. Veuillez la supprimer avant d'en programmer une nouvelle."
            },
            "steps": {
                "select_download_code": "Étape {{step}} sur {{maxStep}} : Sélectionner un code de téléchargement",
                "confirm": "Étape {{step}} sur {{maxStep}} : Confirmer la création de l'enveloppe"
            },
            "confirmation": {
                "message": "Vous êtes sur le point de programmer une enveloppe de téléchargement basée sur le code de téléchargement \"{{downloadCode}}\".",
                "question": "Souhaitez-vous confirmer ?"
            }
        }
    },
    "status": {
        "TO_BE_ACTIVATED": "En attente",
        "ACTIVATED": "Activé",
        "TERMINATED": "Résilié",
        "IN_STOCK": "En stock"
    },
    "text": {
        "is_direct": "Abonnement direct"
    },
    "tooltip": {
        "badge": {
            "migrate": "Migration en cours",
            "terminate": "Une résiliation a été programmée pour cet abonnement au {{resiliationDate}}",
            "restock": "Cet abonnement n'est rattaché à aucun marchand. Afin de l'activer, il vous faut d'abord le remettre en stock.",
            "activate": "Cet abonnement n'est rattaché à aucun marchand. Il le sera dès qu'une autorisation, télécollecte, ou téléparamétrage aura eu lieu."
        },
        "date": {
            "alert": {
                "warning": "Dernière connexion {{days}}",
                "error": "Dernière connexion il y a {{days}} jours ou plus"
            }
        }
    }
}